import {refreshBasketFly} from './refresh-basket-fly';
(function () {
    if (window.BX && typeof window.BX.addCustomEvent === 'function') {
        window.BX.addCustomEvent('onCompleteAction', async (eventData) => {
            if (!eventData || !eventData.action) return;
            if (String(eventData.action).indexOf('loadBasket') === 0) {
                await refreshBasketFly();
            }
        });
    }
})();
